var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pvp-info-box",class:`box-${_vm.variant}`},[(_vm.icon)?_c('Icon',{staticClass:"box-icon",attrs:{"name":_vm.icon}}):_vm._e(),_c('div',{staticClass:"box-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }